import { useQuery } from "@tanstack/react-query";
import type { Client, TestimonialWithClient } from "@shared/schema";

function buildUrl(base: string, params?: Record<string, string | number | boolean | undefined>) {
  if (!params) return base;
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null) searchParams.set(k, String(v));
  });
  const qs = searchParams.toString();
  return qs ? `${base}?${qs}` : base;
}

export function useClients(options?: { featured?: boolean; industry?: string; service?: string; enabled?: boolean }) {
  const url = buildUrl("/api/clients", {
    featured: options?.featured ? "true" : undefined,
    industry: options?.industry,
    service: options?.service,
  });
  return useQuery<Client[]>({ queryKey: [url], enabled: options?.enabled !== false });
}

export function useFeaturedClientLogos() {
  return useClients({ featured: true });
}

export function useTestimonials(options?: {
  featured?: boolean;
  service?: string;
  clientId?: number;
  limit?: number;
}) {
  const url = buildUrl("/api/testimonials", {
    featured: options?.featured ? "true" : undefined,
    service: options?.service,
    clientId: options?.clientId,
    limit: options?.limit,
  });
  return useQuery<TestimonialWithClient[]>({ queryKey: [url] });
}

export function useRandomTestimonials(count: number, service?: string) {
  const url = buildUrl("/api/testimonials/random", { count, service });
  return useQuery<TestimonialWithClient[]>({
    queryKey: [url],
    staleTime: 0,
  });
}
